import React from "react";
import styled from "styled-components";
import { useInView } from "react-hook-inview";

interface IProps {
  count: number;
  style: any;
  path: string;
}

const pad = (number: number) =>
  number <= 99 ? `0${number}`.slice(-2) : number;

const Tile: React.FC<IProps> = React.memo(props => {
  const [ref, isVisible] = useInView({
    threshold: 0
  });

  try {
    const src = require(`../../../public/boxes/${props.path}_${pad(
      props.count
    )}.jpg`);
    return (
      <TileWrapper style={props.style} ref={ref}>
        <TilePicture
          className={isVisible ? "active" : ""}
          src={src}
          alt="Map loading..."
        />
      </TileWrapper>
    );
  } catch (err) {
    return null;
    //Do whatever you want when the image failed to load here
  }
});

const TileWrapper = styled.div`
  pointer-events: none;
  position: absolute;
  top: 50%;
  left: 50%;
  user-select: none;
`;

const TilePicture = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  width: 100%;
  background-size: cover;
  display: none;
  &.active {
    display: block;
  }
  * {
    width: 100%;
    height: 100%;
  }
`;

export default Tile;
